import React from 'react'

interface FiltersProps {
  children: React.ReactNode;
}

export function Filters ({ children }: FiltersProps) {
  return <div className='flex flex-col space-y-2 p-4'>{children}</div>
}

Filters.displayName = 'FiltersDropdown.Filters'
